import { createCRUDEntity } from '../crud-factory';
import { transformMedicalProcedureData } from '../transformations';

// MedicalProcedure Entity
export const MedicalProcedure = createCRUDEntity(
  'medical_procedures',
  transformMedicalProcedureData
);
